import { z } from "zod";
import { uuidLoose } from "./uuid.js";
// Exported for Drizzle pgEnum reuse + downstream API/UI iteration.
// P17 adds `cod` — gated at checkout-time by `companies.cod_enabled`.
export const PaymentModeValues = ["now", "invoice", "cod"];
export const PaymentMode = z.enum(PaymentModeValues);
/**
 * `POST /v1/storefront/checkout` request body — wire-format DTO.
 *
 * `companyLocationId` is REQUIRED — the cart's location must be set by this
 * point. Storefront UI fills it from `customer.defaultLocationId` when the
 * buyer has only one allowed location, or from the dropdown selection when
 * multiple. An invalid (cross-customer, unauthorised) location ID is a 403.
 *
 * `payment_mode` (P15): customer-selected checkout routing. `undefined` means
 * the server picks a default based on `companies.payment_terms`:
 *   - `immediate` → server forces `"now"` (existing P06 flow)
 *   - `net_30` / `net_60` → server defaults to `"invoice"`; `"now"` allowed if
 *     the buyer wants to pay upfront despite their terms.
 * snake_case matches the wire-protocol convention used in the spec §3.3 (and
 * mirrors `cart-bodies.ts:SwitchActiveLocationBody.company_location_id`).
 *
 * `companyLocationId` uses `uuidLoose` (not strict `z.uuid()`) so the P02-T12
 * seed's version-0 UUIDs are accepted during dev/staging. See uuid.ts.
 */
export const CheckoutBody = z.object({
    companyLocationId: uuidLoose,
    payment_mode: PaymentMode.optional(),
});
